import React, { useCallback, useEffect, useState } from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import WrittingQuiz from "./pages/quiz/WrittingQuiz";
import GenerateExercise from "./pages/exercise/GenerateExercise";
import { Inspection } from "./components/Inspection/Inspection";
import { FillInBlanks } from "./components/fill_in_blanks/fill_in_blanks";
import MaterialApp from "./MaterialApp";
import QuizSubmit from "./components/true_false_questions/QuizSubmit";
import QuizRunner from "./pages/quiz/QuizRunner";
import B2CAssessment from "./pages/b2c_assessment/B2C_Assessment";
import quizAPI from "./libs/api/quiz";
import { baseUrl, GenaiUrl, CreateQuizUrl,isB2C, isEuro, isNovium, TempUrl,MaterialUrl } from "./libs/env";
import Error from "./erros/Error";
import PreviewTemplate from "./pages/exercise/PreviewTemplate";
import { isLocalHosted } from "./libs/env";
import { exerciseType } from "./components/constants/constants";
import { useHistory,useLocation } from "react-router-dom";
import { CustomOriginProvider, useCustomOrigin } from "./components/custom_origin/CustomOriginContext";

export const getQuizId = () => {
  let id;
  if (window.location.pathname.includes(GenaiUrl) || window.location.pathname.includes(TempUrl)) {
    id = window.location.pathname.split("/")[3];
  } else {
    id = window.location.pathname.split("/")[2];
  }
  return id;
};

const App = (props) => {
  let RoutePath = `/:quiz/:id`;
  let CreateExercisePath = `/a/generate`;
  let EditExercisePath = `/a/edit-exercise/:id`;
  let TemplatePath = `/a/preview-template/:id`;

  const [items, setItems] = useState({});
  const [Dropdownitems, setDropdownitems] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSystemRedirection, setIsSystemRedirection] = useState(false);
  const [formError, setformError] = useState({});
  const [IsGenerating, setIsGenerating] = useState(false);
  const [IsFeedbackGenerating, setIsFeedbackGenerating] = useState(false);
  const [ShowSocketData, setShowSocketData] = useState();

  const { pathname } = useLocation();
  let params = new URL(document.location).searchParams;
  let content_type = params.get("type");
  const setSocketCallback = useCallback((isValue) => {
    setShowSocketData(isValue)
  },[]);
  let history = useHistory();
  if (isLocalHosted === false) {
    Inspection();
  }
  let customOrigin = useCustomOrigin();
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (window.location.pathname.includes(CreateQuizUrl) && !window.location.pathname.includes(MaterialUrl))
    { 
      quizAPI
      .getformdata({get_temp:true})
      .then((res) => res.json())
      .then((json) => {
        setDropdownitems(json);
      })
      .catch((error) => console.log(error.message));
    }
    else if(isB2C.some(domain => window.location.origin.includes(domain)) || window.location.origin.includes(isNovium))
    {
      setTimeout(() => {
        quizAPI
        .get({ id: getQuizId() })
        .then((res) => res.json())
        .then((json) => {
          setIsLoaded(true);
          setItems(json);
        })
        .catch((error) => console.log(error.message));
      }, 50);
    }
    else if(!window.location.pathname.includes(MaterialUrl))
    { 
      quizAPI
      .get({ id: getQuizId() })
      .then((res) => res.json())
      .then((json) => {
        setIsLoaded(true);
        setItems(json);
      })
      .catch((error) => console.log(error.message));
      if (window.location.pathname.includes(GenaiUrl))
      {
      quizAPI
      .getformdata()
      .then((res) => res.json())
      .then((json) => {
        setDropdownitems(json);
      })
      .catch((error) => console.log(error.message));
      }
    }

  }, []);
  const GenerateQuiz = (formData) => {
    setIsGenerating(true)
    setformError({});
    quizAPI
      .postformdata({ data: formData })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          // window.location.replace(`${baseUrl}/genai${GenaiUrl}${json.exercise_id}`);
        }
        else
        {
          setIsGenerating(false)
          setformError(json.errors);
        }
      });
  };
  const CreateQuiz = (data,use_template) => {
    const createdData = {is_create: true , createExercisedata: data}
    // setIsSavingExercise(true);
    quizAPI
      .postformdata({ data: createdData })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          if(use_template)
          {
            window.location.replace(`${baseUrl}/a${GenaiUrl}${json.exercise_id}?g_ut=true`);
          }
          else{
            window.location.replace(`${baseUrl}/a${GenaiUrl}${json.exercise_id}`);
          }
          sessionStorage.setItem('popupShown', 'true');
        }
        else{
          console.error(json);
        }
      });
  };
  const GenerateFeedback = (gen_marking) => {
    let feedbackData = {gen_feedback: true}
    if (gen_marking){
      feedbackData = gen_marking
    }
    setIsFeedbackGenerating(true);
    quizAPI
      .post({id: getQuizId(), data: feedbackData })
      .then((res) => res.json())
      .then((json) => {
        if (json.success) {
          console.log(json);
        }
        else{
          console.error(json);
          setIsFeedbackGenerating(false);
        }
      });
  };
  const updateQuiz = (data) => {
        const updatedData = {is_edit: true , updatedQuizdata: data}
        // setIsSubmitting(true);
        quizAPI
          .post({ id: getQuizId(), data: updatedData })
          .then((res) => res.json())
          .then((json) => {
            console.log(json);
          });
    };
  const submitQuiz = useCallback(
    (data, redirection) => {
      if (data.is_submit) {
        setIsSubmitting(true);
        quizAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            setIsSubmitting(false);
            setIsLoaded(true);
            if (!redirection) {
              setItems(json);
              scrollTop();
            }

            if (json.message === "Already submitted.") {
              localStorage.clear();
              setIsSystemRedirection(true);
              if(window.location.origin.includes(isNovium) ||  (customOrigin && customOrigin.includes(isNovium)))
              {
                window.location.replace(
                  `${baseUrl}/student/assignments?task_completed=true`
                );
              }
              else if(window.location.origin.includes(isEuro))
                {
                  const category_id = window.sessionStorage.getItem("test_category_id");
                  if (category_id){
                    window.location.replace(
                      `${baseUrl}/el/student/assignments/${category_id}?task_completed=true`
                    );
                  }
                  else{
                    window.location.replace(
                      `${baseUrl}?task_completed=true`
                    );
                  }
                }
              else if(isB2C.some(domain => window.location.origin.includes(domain)))
              {
                window.location.replace(
                  `${baseUrl}/user/assessments?task_completed=true`
                );
              }
              else
              {
                window.location.replace(
                  `${baseUrl}/student/assignments?task_completed=true`
                );
              }
            }

            if (json.is_show_feedback === false) {
              setIsSystemRedirection(true);
              history.push("/stagging");
            }
          });
      } else {
        quizAPI
          .post({ id: getQuizId(), data })
          .then((res) => res.json())
          .then((json) => {
            if (redirection) {
              setIsSystemRedirection(true);
              if(window.location.origin.includes(isNovium) || (customOrigin && customOrigin.includes(isNovium)))
              {
                window.location.replace(
                  `${baseUrl}/student/assignments`
                );
              }
              else if(window.location.origin.includes(isEuro))
                {
                  const category_id = window.sessionStorage.getItem("test_category_id");
                  if (category_id){
                    window.location.replace(
                      `${baseUrl}/el/student/assignments/${category_id}?task_completed=true`
                    );
                  }
                  else{
                    window.location.replace(
                      `${baseUrl}?task_completed=true`
                    );
                  }
                }
              else if(isB2C.some(domain => window.location.origin.includes(domain)))
              {
                window.location.replace(`${baseUrl}/user/assignments`);
              }
              else{
                window.location.replace(`${baseUrl}/student/assignments`);
              }
            }
          });
      }
    },
    [history, customOrigin]
  );
  if (pathname.split("/").length === 4) {
    RoutePath = `/:quiz/:id/:id`;
  }

  if((isB2C.some(domain => window.location.origin.includes(domain))) && content_type === 'assessment')
  {
    return (
      <>
        <Switch>
          <Route exact path={RoutePath}>
            { items.detail ? (
              <Error data={items} isLoaded={isLoaded} />
            ) : (
              <CustomOriginProvider userSource={items ? items.user_source: null}>
              <B2CAssessment
                setIsSystemRedirection={setIsSystemRedirection}
                isSystemRedirection={isSystemRedirection}
                data={items}
                isLoaded={isLoaded}
                onSubmit={submitQuiz}
                isSubmitting={isSubmitting}
                GenerateFeedback={GenerateFeedback}
                IsFeedbackGenerating={IsFeedbackGenerating}
                setIsFeedbackGenerating={setIsFeedbackGenerating}
              />
              </CustomOriginProvider>
            )}
          </Route>
          <Route path={"/stagging"} render={() => (window.location = baseUrl)} />
          <Route exact path={`*`}>
            404 - Not fount
          </Route>
        </Switch>
      </>
    );
  }
  else if(pathname.includes(MaterialUrl))
  {
    return (
      <>
        <MaterialApp />
      </>
    );
  }
  else
  {
    return (
      <>
        <Switch>        
          <Route exact path={CreateExercisePath}>
            <GenerateExercise
              setIsSystemRedirection={setIsSystemRedirection}
              isSystemRedirection={isSystemRedirection}
              data={items}
              isLoaded={isLoaded}
              onSubmit={submitQuiz}
              isSubmitting={isSubmitting}
              onUpdate={updateQuiz}
              Dropdownitems={Dropdownitems}
              GenerateQuiz={GenerateQuiz}
              formError={formError}
              IsGenerating={IsGenerating}
              setIsGenerating={setIsGenerating}
              CreateQuiz={CreateQuiz}
              setIsSubmitting={setIsSubmitting}
              setShowSocketData={setSocketCallback}
              ShowSocketData={ShowSocketData}
            />
          </Route>
          <Route exact path={EditExercisePath}>
            <GenerateExercise
              setIsSystemRedirection={setIsSystemRedirection}
              isSystemRedirection={isSystemRedirection}
              data={items}
              isLoaded={isLoaded}
              onSubmit={submitQuiz}
              isSubmitting={isSubmitting}
              onUpdate={updateQuiz}
              Dropdownitems={Dropdownitems}
              GenerateQuiz={GenerateQuiz}
              formError={formError}
              IsGenerating={IsGenerating}
              setIsGenerating={setIsGenerating}
              CreateQuiz={CreateQuiz}
              setIsSubmitting={setIsSubmitting}
              setShowSocketData={setSocketCallback}
              ShowSocketData={ShowSocketData}
              IsFeedbackGenerating={IsFeedbackGenerating}
              setIsFeedbackGenerating={setIsFeedbackGenerating}
              GenerateFeedback={GenerateFeedback}
            />
          </Route>
          <Route exact path={TemplatePath}>
            <PreviewTemplate
              setIsSystemRedirection={setIsSystemRedirection}
              isSystemRedirection={isSystemRedirection}
              data={items}
              isLoaded={isLoaded}
              onSubmit={submitQuiz}
              isSubmitting={isSubmitting}
              onUpdate={updateQuiz}
            />
          </Route>
          <Route exact path={RoutePath}>
            {items.task_type === exerciseType.WRITING_TASK ? (
              <WrittingQuiz
                setIsSystemRedirection={setIsSystemRedirection}
                isSystemRedirection={isSystemRedirection}
                data={items}
                isLoaded={isLoaded}
                onSubmit={submitQuiz}
                isSubmitting={isSubmitting}
                onUpdate={updateQuiz}
              />
            ) : items.detail ? (
              <Error data={items} isLoaded={isLoaded} />
            ) : (
              <QuizRunner
                setIsSystemRedirection={setIsSystemRedirection}
                isSystemRedirection={isSystemRedirection}
                data={items}
                isLoaded={isLoaded}
                onSubmit={submitQuiz}
                isSubmitting={isSubmitting}
                onUpdate={updateQuiz}
                GenerateFeedback={GenerateFeedback}
                IsFeedbackGenerating={IsFeedbackGenerating}
                setIsFeedbackGenerating={setIsFeedbackGenerating}
              />
            )}
          </Route>
          <Route exact path={`/quizsubmit`}>
            <QuizSubmit data={items} isLoaded={isLoaded} />
          </Route>
          <Route path={"/validations"}>
            <FillInBlanks />
          </Route>
          <Route path={"/quizreview"}>
            {items.task_type === exerciseType.WRITING_TASK ? (
              <WrittingQuiz
                isReview={true}
                data={items}
                isLoaded={isLoaded}
                onSubmit={submitQuiz}
              />
            ) : (
              <QuizRunner
                isReview={true}
                data={items}
                isLoaded={isLoaded}
                onSubmit={submitQuiz}
              />
            )}
          </Route>
          <Route path={"/stagging"} render={() => (window.location = baseUrl)} />
          <Route exact path={`*`}>
            404 - Not fount
          </Route>
        </Switch>
      </>
    );
  }
};

export default App;
